import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { environment } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private afAuth: AngularFireAuth) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApi = request.url.includes(environment.api_url);
    if (!isApi) return next.handle(request);

    // 🔒 Only allow through once we have a token
    return this.afAuth.idToken.pipe(
      // Wait until Firebase has actually produced a token
      filter((token): token is string => !!token),
      take(1),
      switchMap((idToken: string) => {
        let headers = request.headers
          .set('X-App-Key', environment.app_token)
          .set('Authorization', `Bearer ${idToken}`);

        const cloned = request.clone({ headers });
        return next.handle(cloned);
      })
    );
  }
}
